import { render, staticRenderFns } from "./Kwitansi.vue?vue&type=template&id=21034a46&scoped=true&"
import script from "./Kwitansi.vue?vue&type=script&lang=js&"
export * from "./Kwitansi.vue?vue&type=script&lang=js&"
import style0 from "./Kwitansi.vue?vue&type=style&index=0&id=21034a46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21034a46",
  null
  
)

export default component.exports